import { Component, OnInit } from '@angular/core';
import { SettingsService } from '@app/services/settings/settings.service';
import { SharedModule } from '@app/shared/shared.module';
import { ListFormComponent } from '../list-form/list-form.component';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { ListsService } from '../lists.service';
import { ListsApi } from '../lists.api';
import { Toaster } from '@app/services/toaster/toaster.service';

@Component({
  selector: 'app-send-list',
  standalone: true,
  imports: [
		SharedModule,
		ListFormComponent,
	],
	providers: [
		ListsService,
		ListsApi,
	],
  templateUrl: './send-list.component.html',
  styleUrl: './send-list.component.scss'
})
export class SendListComponent implements OnInit {
	public pageLoading: boolean = true;
	public loading: boolean = false;
	public open: boolean = false;
	public year:string = "...";

	constructor(
		private toast: Toaster,
		private nav: NavigationService,
		private settings: SettingsService,
		private service: ListsService,
	) { }

	ngOnInit(): void {
		this.loadSettings();
	}

	private async loadSettings() {
		this.pageLoading = true;
		this.open = await this.settings.isOpen();
		this.year = (await this.settings.getSubscriptionYear()).toString();
		this.pageLoading = false;
	}

	public goTerms = () => this.nav.goTerms();
	public goRules = () => this.nav.goRules();
	public goCebs = () => this.nav.goRulesCelebrity();

	public register(data: any) {
		this.loading = true;
		this.service.register(data)
			.subscribe({
				next: (rs) => {
					this.loading = false;
					this.toast.success("Sua lista foi enviada!");
					this.nav.goViewList(rs.hash);
				},
				error: (err) => {
					if(err.code == 4042) { 
						console.error("e-mail already in use!");
					}
					this.loading = false;
				}
			})
	}

}
